export function NotFound (): JSX.Element {
  return (
    <div className='row'>
      <div className='col-xs-12'>Not Found</div>
    </div>
  )
}
